import type { ResolvedComponent } from "@inertiajs/react";

const pages = import.meta.glob<{ default: ResolvedComponent }>(
  "./pages/**/*.tsx",
);

export function resolvePage(name: string): Promise<ResolvedComponent> {
  const page = pages[`./pages/${name}.tsx`];

  if (!page)
    throw new Error(
      `Unknown page ${name}. Is it located under Pages with a .tsx extension?`,
    );

  return page().then((module) => module.default);
}
